import {ImageLoader,TextureLoader,LoadingManager} from "three";
import bidello,{component} from 'bidello';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader.js';


class Assets extends component(LoadingManager) {

    init(){

        this.onLoad = this.onLoadComplete;
        this.onProgress = this.onLoadProgress

    }

    onLoadComplete(){

        bidello.trigger({name:"assetsLoadComplete"})

    }

    onLoadProgress(url, itemsLoaded, itemsTotal){

        bidello.trigger({name:"assetsLoadProgress"},{progress:itemsLoaded/itemsTotal})

    }

    onLoadError (){

        bidello.trigger({name:"assetsLoadError"})

    }



}

export const assets = new Assets();